<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="810px" scrollable>
    <v-card>
      <v-card-title>
        <span class="headline">{{ page.title }}</span>
        <v-spacer />
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>

      <v-card-text class="text-xs-center">
        <template v-if="page.content">
          <tk-froala v-if="page.content" :content="page.content" />
        </template>
        <template v-else>
          <p v-html="$t('CART.ALAND_ORDER_DESC')"></p>
          <tk-btn
            class="mt-5 mb-3"
            color="primary"
            block
            large
            @click="fetchData"
            :loading="loading"
          >{{ $t('COMMON.READ_MORE') }}</tk-btn>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
import TkFroala from "@/components/core/TkFroala";

const handler = new ErrorHandler();

export default {
  props: ["value"],

  components: { TkFroala },

  data() {
    return {
      loading: false,
      page: {},
    };
  },

  methods: {
    async fetchData() {
      this.page = {};

      this.loading = true;
      await handler.handle(async () => {
        const res = await this.$axios.get(`pages/aland`);
        this.page = res.data["data"];
      });
      this.loading = false;
    },
  },
};
</script>

